<template><k-dialog v-model="dialog_open" :fullscreen="true" persistent scrollable><k-card>
	<k-card-title style="border-bottom:1px solid #999; background-color:#ddd;"><b>Import Text Summary From PDF using LLM <span class="pink--text text--darken-3">(BETA)</span></b>
		<k-spacer/>
		<k-btn color="secondary" @click="$emit('cancel_import')"><k-icon small class="mr-2">fas fa-xmark</k-icon>Cancel</k-btn>
	</k-card-title>
	<k-card-text class="mt-3 k-ai-import-interface-wrapper" style="font-size:16px">
		<div class="mb-4">
			<div style="border:1px solid #ccc; background:#e9e9e9; padding:12px; border-radius:6px;">
				<div class="mb-2">
					<b>Resource Import Settings</b>
				</div>

				<div class="d-flex flex-wrap align-end">
					<div class="mr-3 mb-2" style="flex:1 1 350px; max-width:500px;">
						<div class="mb-1"><b>Textbook Title:</b></div>

						<v-text-field
							background-color="#fff"
							outlined
							dense
							hide-details
							v-model="textbook_title"
						></v-text-field>
					</div>

					<div class="mb-2" style="flex:0 1 220px; min-width:180px;">
						<div class="mb-1"><b>Item Type:</b></div>

						<v-text-field
							background-color="#fff"
							outlined
							dense
							hide-details
							v-model="item_type"
						></v-text-field>
					</div>
				</div>
			</div>
			<div class="mt-3" style="border:1px solid #ccc; background:#f8f8f8; padding:12px; border-radius:6px;">
				<div>
					<div class="d-flex align-center">
						<b>Prompt:</b>
					</div>

					<div class="mt-2">
						<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="2"
							v-model="prompt"
						></k-textarea>
					</div>
				</div>
				<div class="d-flex flex-wrap align-center mt-3">
					<b class="mr-2">Sources files:</b>

					<k-btn v-for="(file) in ai_import_files" :key="file.name" small outlined color="secondary" class="k-tight-btn k-nocaps-btn mr-2" @click="remove_file(file)"><span style="font-weight:normal">{{file.name}}</span><k-icon small class="ml-2">fas fa-circle-minus</k-icon></k-btn>
					<k-btn small color="primary" class="k-tight-btn k-nocaps-btn" @click="add_file"><k-icon small class="mr-2">fas fa-plus</k-icon>Add File</k-btn>
					<k-btn v-if="ai_import_files.length > 0" small color="secondary" class="k-tight-btn k-nocaps-btn ml-2" @click="downscale_pdfs"><k-icon small class="mr-2">fas fa-compress</k-icon>Downscale PDFs</k-btn>
				</div>

				<k-checkbox	class="mt-1 pt-0" hide-details v-model="downscale_pdfs_before_run" label="Downscale PDFs before sending to Gemini"></k-checkbox>
				<div class="mt-4">
					<div class="d-flex align-center">
						<b>Google Drive Source:</b>
						<k-spacer/>
						<div v-if="google_drive_source_loading" class="mr-2">Loading Google Drive source...</div>
						<div v-if="google_drive_source_error" class="red--text text--darken-2 mr-2">{{ google_drive_source_error }}</div>
					</div>

					<div class="mt-2 d-flex align-center">
						<div style="flex:1 1 auto" class="mr-2">
							<v-text-field background-color="#fff" outlined dense hide-details placeholder="Paste Google Docs link here"
								v-model="google_drive_link"
							></v-text-field>
						</div>

						<k-btn small color="primary" class="k-tight-btn k-nocaps-btn mr-2" @click="get_google_drive_markdown" :disabled="google_drive_source_loading || !google_drive_link">Get Markdown</k-btn>
						<k-btn small color="primary" class="k-tight-btn k-nocaps-btn mr-2" @click="get_google_drive_plain_text" :disabled="google_drive_source_loading || !google_drive_link">Get Plain Text</k-btn>
						<k-btn small color="primary" class="k-tight-btn k-nocaps-btn" @click="get_google_drive_html" :disabled="google_drive_source_loading || !google_drive_link">Get HTML</k-btn>
					</div>

					<div class="mt-3">
						<div class="d-flex align-center">
							<b>Google Drive Source Preview:</b>
							<k-spacer/>
							<k-btn x-small color="secondary" class="k-tight-btn k-nocaps-btn" @click="clear_google_drive_source" :disabled="!google_drive_source_text && !google_drive_link">Clear</k-btn>
						</div>

						<div class="mt-2">
							<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" outlined dense hide-details placeholder="Fetched Google Drive source text will appear here. You can edit it before running." rows="8"
								v-model="google_drive_source_text"
							></k-textarea>
						</div>
					</div>
				</div>
			</div>

			<!-- Commenting out Additional Prompts for first iteration of ghostScript
			<div class="mt-2">
				<k-btn small color="primary" class="k-tight-btn k-nocaps-btn" @click="add_additional_prompt"><k-icon small class="mr-2">fas fa-plus</k-icon>Add Additional Prompt</k-btn>
			</div>-->
			<div v-for="(p, pi) in extra_prompts" :key="pi" class="mt-4">
				<div style="border:1px solid #ccc; background:#f8f8f8; padding:12px; border-radius:6px;">
					<div class="d-flex align-center">
						<b>Prompt {{pi + 2}}:</b>
						<k-spacer/>
						<k-btn small outlined color="red darken-2" class="k-tight-btn k-nocaps-btn" @click="remove_prompt(pi)"><k-icon small class="mr-2">fas fa-trash</k-icon>Remove Prompt
						</k-btn>
					</div>

					<div class="mt-2">
						<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details rows="2"
							v-model="p.prompt"
						></k-textarea>
					</div>

					<div class="d-flex flex-wrap align-center mt-3">
						<b class="mr-2">Sources files:</b>

						<k-btn v-for="(file) in p.files" :key="file.name" small outlined color="secondary" class="k-tight-btn k-nocaps-btn mr-2" @click="remove_file_for_prompt(pi, file)"><span style="font-weight:normal">{{file.name}}</span><k-icon small class="ml-2">fas fa-circle-minus</k-icon></k-btn>
						<k-btn small color="primary" class="k-tight-btn k-nocaps-btn" @click="add_file_for_prompt(pi)"><k-icon small class="mr-2">fas fa-plus</k-icon>Add File</k-btn>
					</div>

					<div class="mt-4">
						<div class="d-flex align-center">
							<b>Google Drive Source:</b>
							<k-spacer/>
							<div v-if="p.google_drive_source_loading" class="mr-2">Loading Google Drive source...</div>
							<div v-if="p.google_drive_source_error" class="red--text text--darken-2 mr-2">{{ p.google_drive_source_error }}</div>
						</div>

						<div class="mt-2 d-flex align-center">
							<div style="flex:1 1 auto" class="mr-2">
								<v-text-field background-color="#fff" outlined dense hide-details placeholder="Paste Google Docs link here"
									v-model="p.google_drive_link"
									@input="on_extra_prompt_google_drive_link_change(pi)"
								></v-text-field>
							</div>

							<k-btn small color="primary" class="k-tight-btn k-nocaps-btn mr-2" @click="get_extra_prompt_google_drive_markdown(pi)" :disabled="p.google_drive_source_loading || !p.google_drive_link">Get Markdown</k-btn>
							<k-btn small color="primary" class="k-tight-btn k-nocaps-btn mr-2" @click="get_extra_prompt_google_drive_plain_text(pi)" :disabled="p.google_drive_source_loading || !p.google_drive_link">Get Plain Text</k-btn>
							<k-btn small color="primary" class="k-tight-btn k-nocaps-btn" @click="get_extra_prompt_google_drive_html(pi)" :disabled="p.google_drive_source_loading || !p.google_drive_link">Get HTML</k-btn>
						</div>

						<div class="mt-3">
							<div class="d-flex align-center">
								<b>Google Drive Source Preview:</b>
								<k-spacer/>
								<k-btn x-small color="secondary" class="k-tight-btn k-nocaps-btn" @click="clear_extra_prompt_google_drive_source(pi)" :disabled="!p.google_drive_source_text && !p.google_drive_link">Clear</k-btn>
							</div>

							<div class="mt-2">
								<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" outlined dense hide-details placeholder="Fetched Google Drive source text will appear here. You can edit it before running." rows="8"
									v-model="p.google_drive_source_text"
								></k-textarea>
							</div>
						</div>
					</div>
				</div>

				<div class="mt-2">
					<k-btn small color="primary" class="k-tight-btn k-nocaps-btn" @click="add_additional_prompt"><k-icon small class="mr-2">fas fa-plus</k-icon>Add Additional Prompt</k-btn>
				</div>
			</div>
			
		</div>

		<div class="d-flex mt-4">
			<div style="flex:1 1 50%" class="mr-4">
				<div>
					<div class="d-flex align-center mb-3">
						<div style="width:320px">
							<v-select
								v-model="model"
								:items="model_options"
								label="Model"
								dense
								outlined
								hide-details
							></v-select>
						</div>

						<k-spacer/>

						<k-btn small color="primary" @click="run_prompt_once_start"><k-icon small class="mr-2">fas fa-person-running</k-icon>Run</k-btn>
					</div>
				</div>

				<div>
					<div class="d-flex align-center mb-2">
						<b v-show="alt_prompt_showing=='system_prompt'" class="mr-3" style="white-space:nowrap;">System Prompt:</b>
						<b v-show="alt_prompt_showing=='satchelscript_protocol'" class="mr-3" style="white-space:nowrap;">Protocol:</b>
						<b v-show="alt_prompt_showing=='extraction_logic'" class="mr-3" style="white-space:nowrap;">Extraction Logic:</b>
						<b v-show="alt_prompt_showing=='schema'" class="mr-3" style="white-space:nowrap;">Output Schema:</b>

						<v-btn-toggle dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" v-model="alt_prompt_showing" mandatory>
							<k-btn small light class="k-tight-btn k-nocaps-btn" value="system_prompt">System Prompt</k-btn>
							<k-btn small light class="k-tight-btn k-nocaps-btn" value="satchelscript_protocol">SatchelScript Protocol</k-btn>
							<k-btn small light class="k-tight-btn k-nocaps-btn" value="extraction_logic">Extraction Logic</k-btn>
							<k-btn small light class="k-tight-btn k-nocaps-btn" value="schema">Output Schema</k-btn>
						</v-btn-toggle>

						<k-spacer/>

						<k-btn v-show="alt_prompt_showing=='system_prompt'" small color="secondary" @click="use_default_system_prompt">Use Default</k-btn>
						<k-btn v-show="alt_prompt_showing=='satchelscript_protocol'" small color="secondary" @click="use_default_satchelscript_protocol">Use Default</k-btn>
						<k-btn v-show="alt_prompt_showing=='extraction_logic'" small color="secondary" @click="get_extraction_logic_from_file">Upload</k-btn>
						<k-btn v-show="alt_prompt_showing=='schema'" small color="secondary" @click="use_default_schema">Use Default</k-btn>
					</div>

					<div v-show="alt_prompt_showing=='system_prompt'">
						<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
							v-model="system_prompt"
						></k-textarea>
					</div>

					<div v-show="alt_prompt_showing=='satchelscript_protocol'">
						<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
							v-model="satchelscript_protocol"
						></k-textarea>
					</div>

					<div v-show="alt_prompt_showing=='extraction_logic'">
						<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
							v-model="extraction_logic"
						></k-textarea>
					</div>

					<div v-show="alt_prompt_showing=='schema'">
						<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
							v-model="schema"
						></k-textarea>
					</div>
				</div>
			</div>

			<div style="flex:1 1 50%" class="mr-4 mt-10">
				<div class="d-flex align-end">
					<b>LLM Response:</b>
					<k-spacer/>
					<k-tooltip bottom><template v-slot:activator="{on}">
						<k-btn v-on="on" small icon outlined color="primary" @click="copy_to_clipboard(last_response)" class="mr-2 k-tight-btn k-nocaps-btn" :disabled="!last_response"><k-icon small>fas fa-copy</k-icon></k-btn>
					</template>Copy last response to clipboard</k-tooltip>

					<!-- k-text-field to allow user to enter an education_level -->
					<div style="width:80px" class="mr-2">
						<k-select background-color="#fff" label="Low" outlined dense hide-details
							v-model="grade_low"
							:items="grades"
							:menu-props="{ top: true, dense: true }"
						></k-select>
					</div>
					<div style="width:80px" class="mr-2">
						<k-select background-color="#fff" label="High" outlined dense hide-details
							v-model="grade_high"
							:items="grades"
							:menu-props="{ top: true }"
						></k-select>
					</div>
					<k-btn v-show="grade_low && grade_high" small color="primary" class="k-tight-btn k-nocaps-btn mr-2" @click="add_education_level" :disabled="!last_response"> Add Education Levels</k-btn>

					<k-btn small color="primary" class="k-tight-btn k-nocaps-btn" @click="add_to_satchel_script">Add To Satchel Script<k-icon small class="ml-2">fas fa-arrow-right</k-icon></k-btn>
				</div>
				<div class="mt-2">
					<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
						v-model="last_response"
					></k-textarea>
				</div>
				<div class="mt-2" v-if="last_usage_metadata">
					<div><b>Last Response Cost:</b> <span v-html="last_response_cost_display"></span></div>
					<div v-if="previous_last_response_cost_display"><b>Previous:</b> <span v-html="previous_last_response_cost_display"></span></div>
					<div v-if="cumulative_response_cost_display" v-html="cumulative_response_cost_display"></div>
					<div>Elapsed time: {{elapsed_time_string}}</div>
				</div>
			</div>

			<div v-if="satchel_script" style="flex:1 1 50%">
				<div class="d-flex align-end mr-4 mt-13">
					<b>Satchel Script:</b>
					<k-spacer/>
					<k-tooltip bottom><template v-slot:activator="{on}">
						<k-btn v-on="on" small icon outlined color="primary" @click="clear_satchel_script" class="mr-2 k-tight-btn k-nocaps-btn" :disabled="!satchel_script"><k-icon small>fas fa-broom-wide</k-icon></k-btn>
					</template>Clear Satchel Script</k-tooltip>
					<k-tooltip bottom><template v-slot:activator="{on}">
						<k-btn v-on="on" small icon outlined color="primary" @click="undo_satchel_script" class="mr-2 k-tight-btn k-nocaps-btn" :disabled="last_satchel_script===null" v-show="next_satchel_script===null"><k-icon small>fas fa-undo</k-icon></k-btn>
					</template>Undo last change to Satchel Script</k-tooltip>
					<k-tooltip bottom><template v-slot:activator="{on}">
						<k-btn v-on="on" small icon outlined color="primary" @click="redo_satchel_script" class="mr-2 k-tight-btn k-nocaps-btn" v-show="next_satchel_script!==null"><k-icon small>fas fa-redo</k-icon></k-btn>
					</template>redo last change to Satchel Script</k-tooltip>
					<k-tooltip bottom><template v-slot:activator="{on}">
						<k-btn v-on="on" small icon outlined color="primary" @click="copy_to_clipboard(satchel_script)" class="mr-2 k-tight-btn k-nocaps-btn" :disabled="!satchel_script"><k-icon small>fas fa-copy</k-icon></k-btn>
					</template>Copy Satchel Script to clipboard</k-tooltip>
					<k-btn small color="primary" @click="$emit('paste_contents', satchel_script)" class="ml-2 k-tight-btn k-nocaps-btn" :disabled="!satchel_script"><k-icon small class="mr-2">fas fa-paste</k-icon>Paste to Import</k-btn>
					<k-btn small color="primary" class="k-tight-btn k-nocaps-btn ml-2" @click="add_item" :disabled="!satchel_script"><k-icon small class="mr-2">fas fa-plus</k-icon>Add Item</k-btn>
				</div>
				<div class="mt-2">
					<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
						v-model="satchel_script"
					></k-textarea>
				</div>
			</div>

		</div>
	</k-card-text>
</k-card></k-dialog></template>

<script>
import { mapState, mapGetters } from 'vuex'
// import TemplateComponent from '@/components/TemplateComponent'
import CopyBtn from '../utilities/CopyBtn.vue'

// SEE FOR REFERENCE: ItemImportInterface, ItemCSVImportInterface
export default {
	components: {
		CopyBtn
	},
	props: {
		editor_component: { required: true },
	},
	data() { return {
		dialog_open: true,
		last_satchel_script: null,
		next_satchel_script: null,
		// costs are $ per 1M tokens
		default_model: 'gemini-3-flash-preview',
		available_models: {
			'gemini-2.5-flash-lite': { input_cost:'0.10', cached_input_cost:'0.01', output_cost:'0.40', temperature: 0, },
			'gemini-3.1-flash-lite': { input_cost:'0.25', cached_input_cost:'0.025', output_cost:'1.50', temperature: 0, },
			'gemini-3-flash-preview': { input_cost:'0.50', cached_input_cost:'0.05', output_cost:'3.00', temperature: 1, },
			'gemini-3.5-flash': { input_cost:'1.50', cached_input_cost:'0.15', output_cost:'9.00', temperature: 1, },
			'gemini-3-pro-preview': { input_cost:'2.00', cached_input_cost:'0.20', output_cost:'12.00', temperature: 1, },
			'gemini-3.8-flash': { input_cost:'2.00', cached_input_cost:'0.20', output_cost:'12.00', temperature: 1, },
		},

		n_runs: 0,
		total_cost_sum: 0,
		previous_last_response_cost_display: '',

		educationLevel: [],
		extra_prompts: [],

		alt_prompt_showing: 'extraction_logic',

		default_satchelscript_protocol: '',
		default_extraction_logic: '',
		default_system_prompt: '',
		default_schema: '',

		google_drive_link: '',
		google_drive_source_text: '',
		google_drive_source_loading: false,
		google_drive_source_error: '',
		google_drive_source_type: '',

		//downscale_pdfs_before_run: false,
		// track the File objects that have already been downscaled so repeated Run clicks don't downscale the same PDF again
		downscaled_pdf_files: new WeakSet(),

		process_files_together: false,

		elapsed_seconds: 0,
	}},
	computed: {
		...mapState(['user_info', 'ai_import_files', 'ai_force_reprocess_files']),
		...mapGetters([]),
		model_options() {
			let arr = []
			for (let model in this.available_models) {
				let val = this.available_models[model]
				arr.push({value: model, text: `${model} (${val.input_cost}/${val.output_cost})`})
			}
			return arr
		},

		elapsed_time_string() {
			let m = Math.floor(this.elapsed_seconds / 60)
			let s = this.elapsed_seconds % 60
			if (s < 10) return `${m}:0${s}`
			else return `${m}:${s}`
		},

		// note that some of the below are stored in lst, some are stored in state, and some have default values loaded from files
		model: {
			get() { 
				let s = this.$store.state.lst.ai_import_model 
				if (empty(s) || empty(this.available_models[s])) s = this.default_model
				return s
			},
			set(val) { this.$store.commit('lst_set', ['ai_import_model', val]) }
		},
		prompt: {
			get() { return this.$store.state.lst.ai_import_prompt },
			set(val) { this.$store.commit('lst_set', ['ai_import_prompt', val]) }
		},
		
		system_prompt: {
			get() { 
				let s = this.$store.state.lst.ai_import_system_prompt 
				if (!empty(s)) return s
				else return this.default_system_prompt
			},
			set(val) { 
				this.$store.commit('lst_set', ['ai_import_system_prompt', val]) 
			}
		},
		satchelscript_protocol: {
			get() { 
				let s = this.$store.state.lst.ai_import_satchelscript_protocol 
				if (!empty(s)) return s
				else return this.default_satchelscript_protocol
			},
			set(val) { 
				this.$store.commit('lst_set', ['ai_import_satchelscript_protocol', val]) 
			}
		},
		extraction_logic: {
			get() { 
				let s = this.$store.state.lst.ai_import_extraction_logic 
				if (!empty(s)) return s
				else return this.default_extraction_logic
			},
			set(val) { 
				this.$store.commit('lst_set', ['ai_import_extraction_logic', val]) 
			}
		},
		schema: {
			get() { 
				let s = this.$store.state.lst.ai_import_schema 
				if (!empty(s)) return s
				else return this.default_schema
			},
			set(val) { 
				this.$store.commit('lst_set', ['ai_import_schema', val]) 
			}
		},
		downscale_pdfs_before_run: {
			get() {
				return this.$store.state.lst.resource_ai_import_downscale_pdfs_before_run
			},

			set(val) {
				this.$store.commit('lst_set', ['resource_ai_import_downscale_pdfs_before_run', val])
			}
		},
		textbook_title: {
			get() {
				return this.$store.state.lst.resource_ai_import_textbook_title
			},

			set(val) {
				this.$store.commit('lst_set', ['resource_ai_import_textbook_title', val])
			}
		},
		item_type: {
			get() {
				return this.$store.state.lst.resource_ai_import_item_type
			},
			set(val) {
				this.$store.commit('lst_set', ['resource_ai_import_item_type', val])
			}
		},

		last_response: {
			get() { return this.$store.state.lst.ai_import_last_response },
			set(val) { this.$store.commit('lst_set', ['ai_import_last_response', val]) }
		},
		last_usage_metadata: {
			get() { return this.$store.state.lst.ai_import_last_usage_metadata },
			set(val) { this.$store.commit('lst_set', ['ai_import_last_usage_metadata', val]) }
		},
		satchel_script: {
			get() { return this.$store.state.lst.ai_import_satchel_script },
			set(val) { this.$store.commit('lst_set', ['ai_import_satchel_script', val]) }
		},

		last_response_cost() {
			let lum = this.last_usage_metadata
			if (empty(lum?.promptTokenCount)) return 0
			let m = this.available_models[lum.modelVersion]
			if (empty(m)) return 0

			// multiply to get dollar amounts
			let new_input_cost = lum.new_input_tokens / 1000000 * m.input_cost
			let cached_input_cost = lum.cached_input_tokens / 1000000 * m.cached_input_cost
			let output_cost = lum.output_tokens / 1000000 * m.output_cost
			let total_cost = new_input_cost + cached_input_cost + output_cost

			// convert to cents
			total_cost = total_cost * 100
			return total_cost
		},
		last_response_cost_display() {
			if (this.last_response_cost == 0) return ''
			let lum = this.last_usage_metadata
			return `<nobr>[${lum.new_input_tokens}/${lum.cached_input_tokens}/${lum.output_tokens}] tokens = ${this.last_response_cost.toFixed(3)}¢</nobr>`
		},
		cumulative_response_cost_display() {
			if (this.n_runs == 0) return ''
			return `<b>Cumulative:</b> ${this.n_runs}: ${this.total_cost_sum.toFixed(3)}¢</nobr>`
		},

		grades() {
			return this.$store.state.grades
		},

		grade_low: {
			get() {
				if (!Array.isArray(this.educationLevel) || this.educationLevel.length === 0) return ''
				let el = this.educationLevel[0]
				if (empty(el)) return ''
				let grade = this.grades.find(g => {
					return g.value == el || (!isNaN(el * 1) && g.value * 1 == el * 1)
				})
				if (!empty(grade)) return grade
				return ''
			},
			set(new_el) {
				const new_val = (new_el && typeof new_el === 'object') ? new_el.value : new_el

				let new_el_index = this.grades.findIndex(g =>
					g.value == new_val || (!isNaN(new_val * 1) && g.value * 1 == new_val * 1)
				)

				let el_high = this.educationLevel[this.educationLevel.length - 1]
				let el_high_index = this.grades.findIndex(g =>
					g.value == el_high || (!isNaN(el_high * 1) && g.value * 1 == el_high * 1)
				)

				if (el_high_index < new_el_index) {
					// if 9th grade was chosen, default to 12, because most HS courses are 9-12
					if (new_val == '09') el_high_index = this.grades.findIndex(g => g.value == '12')
					else el_high_index = new_el_index
				}
				if (new_el_index == 0) el_high_index = new_el_index

				let arr = []
				for (let i = new_el_index; i <= el_high_index; ++i) arr.push(this.grades[i].value)
				this.educationLevel = arr
			}
		},
		grade_high: {
			get() {
				if ( !Array.isArray(this.educationLevel) || this.educationLevel.length === 0) return ''
				let el = this.educationLevel[this.educationLevel.length - 1]
				if (empty(el)) return ''
				let grade = this.grades.find(g => {
					return g.value == el || (!isNaN(el * 1) && g.value * 1 == el * 1)
				})
				if (!empty(grade)) return grade
				return ''
			},
			set(new_el) {
				const new_val = (new_el && typeof new_el === 'object') ? new_el.value : new_el

				let new_el_index = this.grades.findIndex(g =>
					g.value == new_val || (!isNaN(new_val * 1) && g.value * 1 == new_val * 1)
				)

				let el_low = this.educationLevel[0]
				let el_low_index = this.grades.findIndex(g =>
					g.value == el_low || (!isNaN(el_low * 1) && g.value * 1 == el_low * 1)
				)

				if (el_low_index > new_el_index) el_low_index = new_el_index
				if (el_low_index == 0) el_low_index = new_el_index

				let arr = []
				for (let i = el_low_index; i <= new_el_index; ++i) arr.push(this.grades[i].value)
				this.educationLevel = arr
			}
		},
	},
	watch: {
		google_drive_link() {
			this.google_drive_source_text = ''
			this.google_drive_source_type = ''
			this.google_drive_source_error = ''
		},

		grades() {
			const allowed = new Set(this.grades.map(g => g.value))
			this.education_level = (Array.isArray(this.education_level) ? this.education_level : []).filter(v => allowed.has(v))
		},
	},
	created() {
		vapp.resource_ai_import_component = this
	},
	mounted() {
		this.get_default_files()
	},
	methods: {
		async get_default_files() {
			let text
			
			text = await this.get_server_file('custom/system_prompt.md', false)
			if (!text) text = await this.get_server_file('default/default_system_prompt.md')
			this.default_system_prompt = text

			text = await this.get_server_file('custom/satchelscript_encoding_protocol.md', false)
			if (!text) text = await this.get_server_file('default/default_satchelscript_encoding_protocol.md')
			this.default_satchelscript_protocol = text

			text = await this.get_server_file('default/default_extraction_logic.md')
			this.default_extraction_logic = text

			text = await this.get_server_file('custom/schema.json', false)
			if (!text) text = await this.get_server_file('default/default_schema.json')
			this.default_schema = text
		},

		async get_server_file(filename, required = true) {
			let response
			try {
				response = await fetch(`/src/llm_sources/${filename}`)
				if (!response.ok) {
					if (required) console.warn('couldn’t get (1) ' + filename)
					return ''
				}
			} catch(error) {
				if (required) console.warn('couldn’t get (2) ' + filename, error)
				return ''
			}
			try {
				let text = await response.text()
				return text
			} catch(error) {
				console.warn('couldn’t get (3) ' + filename, error)
				return ''
			}
		},

		async get_google_drive_markdown() {
			if (empty(this.google_drive_link)) {
				this.$alert('Please paste a Google Drive link first.')
				return
			}

			this.google_drive_source_loading = true
			this.google_drive_source_error = ''
			this.google_drive_source_text = ''
			this.google_drive_source_type = ''

			try {
				let markdown_contents = await U.get_from_google_drive_async({
					drive_url: this.google_drive_link,
					mime_type: 'text/markdown',
				})

				if (markdown_contents === false) {
					this.google_drive_source_error = 'Unable to get markdown from Google Drive.'
					return
				}

				if (empty(markdown_contents)) {
					this.google_drive_source_error = 'Google Drive returned no markdown.'
					return
				}

				this.google_drive_source_text = markdown_contents
				this.google_drive_source_type = 'markdown'
				this.$inform('Google Drive markdown loaded.')
			} catch (e) {
				console.error('get_google_drive_markdown error', e)
				this.google_drive_source_error = 'Unable to get markdown from Google Drive.'
			} finally {
				this.google_drive_source_loading = false
			}
		},

		async get_google_drive_plain_text() {
			if (empty(this.google_drive_link)) {
				this.$alert('Please paste a Google Drive link first.')
				return
			}

			this.google_drive_source_loading = true
			this.google_drive_source_error = ''
			this.google_drive_source_text = ''
			this.google_drive_source_type = ''

			try {
				let plain_text_contents = await U.get_from_google_drive_async({
					drive_url: this.google_drive_link,
					mime_type: 'text/plain',
				})

				if (plain_text_contents === false) {
					this.google_drive_source_error = 'Unable to get plain text from Google Drive.'
					return
				}

				if (empty(plain_text_contents)) {
					this.google_drive_source_error = 'Google Drive returned no plain text.'
					return
				}

				this.google_drive_source_text = plain_text_contents
				this.google_drive_source_type = 'plain_text'
				this.$inform('Google Drive plain text loaded.')
			} catch (e) {
				console.error('get_google_drive_plain_text error', e)
				this.google_drive_source_error = 'Unable to get plain text from Google Drive.'
			} finally {
				this.google_drive_source_loading = false
			}
		},

		async get_google_drive_html() {
			if (empty(this.google_drive_link)) {
				this.$alert('Please paste a Google Drive link first.')
				return
			}

			this.google_drive_source_loading = true
			this.google_drive_source_error = ''
			this.google_drive_source_text = ''
			this.google_drive_source_type = ''

			try {
				let html_contents = await U.get_from_google_drive_async({
					drive_url: this.google_drive_link,
					mime_type: 'text/html',
				})

				if (html_contents === false) {
					this.google_drive_source_error = 'Unable to get HTML from Google Drive.'
					return
				}

				if (empty(html_contents)) {
					this.google_drive_source_error = 'Google Drive returned no HTML.'
					return
				}

				// uncomment to test raw output from the google API
				// this.google_drive_source_text = html_contents
				let html_with_preserved_italics = this.preserve_google_italic_classes(html_contents)
				let cleaned_html = this.clean_html_basic(html_with_preserved_italics)

				this.google_drive_source_text = cleaned_html
				this.google_drive_source_type = 'html'
				this.$inform('Google Drive HTML loaded.')
			} catch (e) {
				console.error('get_google_drive_html error', e)
				this.google_drive_source_error = 'Unable to get HTML from Google Drive.'
			} finally {
				this.google_drive_source_loading = false
			}
		},

		clear_google_drive_source() {
			this.google_drive_link = ''
			this.google_drive_source_text = ''
			this.google_drive_source_type = ''
			this.google_drive_source_error = ''
		},

		build_prompt_with_google_drive_source(promptText, sourceText, sourceType = '') {
			const prompt = empty(promptText) ? '' : String(promptText).trim()
			const source = empty(sourceText) ? '' : String(sourceText).trim()

			if (empty(source)) return prompt

			let sourceLabel = 'Source Google Drive Text'

			if (sourceType === 'html') sourceLabel = 'Source Google Drive HTML'
			if (sourceType === 'plain_text') sourceLabel = 'Source Google Drive Plain Text'
			if (sourceType === 'markdown') sourceLabel = 'Source Google Drive Markdown'

			return `${prompt}

${sourceLabel}:
${source}`
		},

		on_extra_prompt_google_drive_link_change(pi) {
			const p = this.extra_prompts[pi]
			if (!p) return

			p.google_drive_source_text = ''
			p.google_drive_source_type = ''
			p.google_drive_source_error = ''
		},

		async get_extra_prompt_google_drive_markdown(pi) {
			const p = this.extra_prompts[pi]
			if (!p) return

			if (empty(p.google_drive_link)) {
				this.$alert('Please paste a Google Drive link first.')
				return
			}

			p.google_drive_source_loading = true
			p.google_drive_source_error = ''
			p.google_drive_source_text = ''
			p.google_drive_source_type = ''

			try {
				let markdown_contents = await U.get_from_google_drive_async({
					drive_url: p.google_drive_link,
					mime_type: 'text/markdown',
				})

				if (markdown_contents === false) {
					p.google_drive_source_error = 'Unable to get markdown from Google Drive.'
					return
				}

				if (empty(markdown_contents)) {
					p.google_drive_source_error = 'Google Drive returned no markdown.'
					return
				}

				p.google_drive_source_text = markdown_contents
				p.google_drive_source_type = 'markdown'
				this.$inform(`Google Drive markdown loaded for Prompt ${pi + 2}.`)
			} catch (e) {
				console.error('get_extra_prompt_google_drive_markdown error', e)
				p.google_drive_source_error = 'Unable to get markdown from Google Drive.'
			} finally {
				p.google_drive_source_loading = false
			}
		},

		async get_extra_prompt_google_drive_plain_text(pi) {
			const p = this.extra_prompts[pi]
			if (!p) return

			if (empty(p.google_drive_link)) {
				this.$alert('Please paste a Google Drive link first.')
				return
			}

			p.google_drive_source_loading = true
			p.google_drive_source_error = ''
			p.google_drive_source_text = ''
			p.google_drive_source_type = ''

			try {
				let plain_text_contents = await U.get_from_google_drive_async({
					drive_url: p.google_drive_link,
					mime_type: 'text/plain',
				})

				if (plain_text_contents === false) {
					p.google_drive_source_error = 'Unable to get plain text from Google Drive.'
					return
				}

				if (empty(plain_text_contents)) {
					p.google_drive_source_error = 'Google Drive returned no plain text.'
					return
				}

				p.google_drive_source_text = plain_text_contents
				p.google_drive_source_type = 'plain_text'
				this.$inform(`Google Drive plain text loaded for Prompt ${pi + 2}.`)
			} catch (e) {
				console.error('get_extra_prompt_google_drive_plain_text error', e)
				p.google_drive_source_error = 'Unable to get plain text from Google Drive.'
			} finally {
				p.google_drive_source_loading = false
			}
		},

		async get_extra_prompt_google_drive_html(pi) {
			const p = this.extra_prompts[pi]
			if (!p) return

			if (empty(p.google_drive_link)) {
				this.$alert('Please paste a Google Drive link first.')
				return
			}

			p.google_drive_source_loading = true
			p.google_drive_source_error = ''
			p.google_drive_source_text = ''
			p.google_drive_source_type = ''

			try {
				let html_contents = await U.get_from_google_drive_async({
					drive_url: p.google_drive_link,
					mime_type: 'text/html',
				})

				if (html_contents === false) {
					p.google_drive_source_error = 'Unable to get HTML from Google Drive.'
					return
				}

				if (empty(html_contents)) {
					p.google_drive_source_error = 'Google Drive returned no HTML.'
					return
				}

				let html_with_preserved_emphasis = this.preserve_google_italic_classes(html_contents)
				let cleaned_html = this.clean_html_basic(html_with_preserved_emphasis)

				p.google_drive_source_text = cleaned_html
				p.google_drive_source_type = 'html'
				this.$inform(`Google Drive HTML loaded for Prompt ${pi + 2}.`)
			} catch (e) {
				console.error('get_extra_prompt_google_drive_html error', e)
				p.google_drive_source_error = 'Unable to get HTML from Google Drive.'
			} finally {
				p.google_drive_source_loading = false
			}
		},

		clear_extra_prompt_google_drive_source(pi) {
			const p = this.extra_prompts[pi]
			if (!p) return

			p.google_drive_link = ''
			p.google_drive_source_text = ''
			p.google_drive_source_type = ''
			p.google_drive_source_error = ''
		},

		async add_file() {
			// prompt for file to import
			let file = await U.prompt_promise({
				text: '<p>Use the interface below to specify the file to process.</p>',
				promptType: 'file',
				acceptText: 'Choose File',
				cancelText: 'Cancel',
				disableForEmptyValue: true,
			})
			if (!file) return

			this.ai_import_files.push(file)
		},

		async downscale_pdfs() {
			// only downscale PDF files, ignore other file types
			let pdf_files = this.ai_import_files.filter(file => /\.pdf$/i.test(file.name))

			if (pdf_files.length == 0) {
				this.$alert('No PDF files are attached.')
				return false
			}

			// don't downscale a file that has already been downscaled
			pdf_files = pdf_files.filter(file => !this.downscaled_pdf_files.has(file))

			// all attached PDFs have already been downscaled
			if (pdf_files.length == 0) return true

			let replaced_files = false

			U.loading_start('Downscaling PDFs...')

			try {
				for (let file of pdf_files) {
					let fd = new FormData()
					fd.append('file', file)

					let response = await fetch('/src/downscale_pdf.php', {
						method: 'POST',
						body: fd,
					})

					if (!response.ok) {
						let error_text = await response.text()
						throw new Error(error_text || `HTTP error ${response.status}`)
					}

					let blob = await response.blob()

					// replace the original attached PDF with the downscaled version
					let downscaled_file = new File([blob], file.name, {
						type: 'application/pdf',
					})

					let i = this.ai_import_files.findIndex(x => x == file)

					if (i > -1) {
						this.ai_import_files.splice(i, 1, downscaled_file)
						this.downscaled_pdf_files.add(downscaled_file)
						replaced_files = true
					}

					console.log(`Downscaled PDF: ${file.name} (${file.size} bytes) -> ${downscaled_file.size} bytes`)
					// Uncomment this block when we want to download the downscaled PDF
					/**/
					let url = URL.createObjectURL(blob)
					let filename = file.name.replace(/\.pdf$/i, '') + '-downscaled.pdf'

					let a = document.createElement('a')
					a.href = url
					a.download = filename
					a.click()

					setTimeout(() => {
						URL.revokeObjectURL(url)
					}, 1000)
					/**/
				}

				return true

			} catch (e) {
				console.error('Error downscaling PDFs', e)
				this.$alert(`Unable to downscale PDF: ${e.message}`)
				return false

			} finally {
				if (replaced_files) {
					// Gemini caches uploaded files by filename, so force reprocess
					this.$store.commit('set', ['ai_force_reprocess_files', true])
				}

				U.loading_stop()
			}
		},

		async add_file_for_prompt(pi) {
			// prompt for file to import
			let file = await U.prompt_promise({
				text: '<p>Use the interface below to specify the file to process.</p>',
				promptType: 'file',
				acceptText: 'Choose File',
				cancelText: 'Cancel'
			})
			if (!file) return

			this.extra_prompts[pi].files.push(file)
		},

		async remove_file(file) {
			let val = await U.confirm_promise({
				title: 'Are you sure?',
				text: 'Are you sure you want to remove this file?',
				acceptText: 'Remove',
				acceptColor: 'red darken-3',
			})
			if (!val) return
			// user confirmed

			let i = this.ai_import_files.findIndex(x=>x==file)
			if (i > -1) this.ai_import_files.splice(i, 1)

			// when we remove a file, force reprocessing of files the next time we run. this way, a user can force reprocessing by removing, then readding the same file
			this.$store.commit('set', ['ai_force_reprocess_files', true])
		},

		async remove_file_for_prompt(pi, file) {
			let val = await U.confirm_promise({
				title: 'Are you sure?',
				text: 'Are you sure you want to remove this file?',
				acceptText: 'Remove',
				acceptColor: 'red darken-3',
			})
			if (!val) return

			let arr = this.extra_prompts[pi].files
			let i = arr.findIndex(x => x == file)
			if (i > -1) arr.splice(i, 1)
		},

		async confirm_multi_prompt_run() {
			// total prompts = prompt 1 + extras
			const total_prompts = 1 + this.extra_prompts.length

			// only ask user to confirm if multiple prompts exist
			if (total_prompts <= 1) return true

			let val = await U.confirm_promise({
				title: 'Are you sure?',
				text: `This will run ${total_prompts} prompts. This may take a considerable amount of time to process. Do you confirm that you want to do this?`,
				acceptText: 'Run',
				cancelText: 'Cancel',
				acceptColor: 'primary',
			})

			return !!val
		},

		copy_to_clipboard(s) {
			U.copy_to_clipboard(s)
			this.$inform('Copied!')
		},

		clear_satchel_script() {
			this.last_satchel_script = this.satchel_script
			this.next_satchel_script = null
			this.satchel_script = ''
		},

		add_to_satchel_script() {
			this.last_satchel_script = this.satchel_script
			this.next_satchel_script = null
			if (!empty(this.satchel_script)) {
				this.satchel_script = this.satchel_script.trim() + `\n\n`
			}

			// Currently using a "Add Education Levels" button. We can remove the button and uncomment the code below if we want it to be added in 1 click using the "Add To Satchel Script" button
			// if (!empty(this.educationLevel)) {
			// 	this.add_education_level()
			// }

			this.satchel_script += this.last_response.trim()
			this.$inform('Added to Satchel Script')
		},

		// BJU specific feature that will parse each section of plain text, send each section to Gemini, then create items from each section using the returned payload as its description
		async add_item() {
			if (empty(this.satchel_script)) return

			let lines = this.satchel_script.split('\n')
			let processed_lines = await this.pre_script_resource_summary_import(lines)

			if (!Array.isArray(processed_lines)) {
				this.$alert('Unable to process the Resource Summary import.')
				return
			}

			//this.$emit('paste_contents', processed_lines.join('\n'))
			this.$emit('add_item', processed_lines.join('\n'))
		},

		add_education_level() {
			// there must be response present and low/high education level selected
			if (empty(this.last_response) || empty(this.grade_low) || empty(this.grade_high)) return

			const low = (typeof this.grade_low === 'object') ? this.grade_low.value : this.grade_low
			const high = (typeof this.grade_high === 'object') ? this.grade_high.value : this.grade_high

			// if the low/high values are the same, combine them so there is not an instance of [03-03]
			const bracket = (low === high) ? `[${low}]` : `[${low}-${high}]`

			const lines = this.last_response.split('\n')
			const out = lines.map(line => {
				const lt = (line || '').trimStart()

				// Ignore non-itme lines
				if (lt.startsWith(`EXT-`)) return line
				if (lt.startsWith(`ASSOC-`)) return line
				if (lt.startsWith(`NOTES:`)) return line
				if (lt.startsWith(`*`)) return line

				const m = (line || '').match(/^(\S+\s)(\*+)\s(\[[^\]]+\]\s*)?(.*)$/)
				if (!m) return line

				const itemTypeWithSpace = m[1]
				const stars = m[2]
				const rest = (m[4] || '').trimStart()

				return `${itemTypeWithSpace}${stars} ${bracket} ${rest}`.trimEnd()
			})

			this.last_response = out.join('\n')
			this.$inform('Education Levels Applied')

			// Reset the drop downs so the button is hidden after adding the ed levels. Remove this if we want the selected grade to persist across prompt responses
			this.grade_low = '';
			this.grade_high = '';
		},	

		undo_satchel_script() {
			this.next_satchel_script = this.satchel_script
			this.satchel_script = this.last_satchel_script
			this.last_satchel_script = null
		},

		redo_satchel_script() {
			this.last_satchel_script = this.satchel_script
			this.satchel_script = this.next_satchel_script
			this.next_satchel_script = null
		},

		use_default_system_prompt() {
			this.system_prompt = ''
		},

		use_default_satchelscript_protocol() {
			this.satchelscript_protocol = ''
		},

		use_default_schema() {
			this.schema = ''
		},

		async get_extraction_logic_from_file() {
			let file = await U.prompt_promise({
				text: '<p>Use the file upload interface below to specify the Extraction Logic file, which must be of type “.md”.</p>',
				promptType: 'file',
				acceptText: 'Upload File',
				cancelText: 'Cancel'
			})
			if (!file) return

			// get file contents
			let file_contents = await this.read_file_promise(file)

			if (!file_contents) {
				this.$alert('The file could not be processed.')
				return
			}

			this.extraction_logic = file_contents
		},

		read_file_promise(file) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader()
				reader.onload = e => {
					resolve(e.target.result)
				}
				reader.onerror = e => {
					console.error('reader error:', e)
					reject()
				}
				reader.readAsText(file)
			})
		},

		has_any_ai_import_files() {
			if (this.ai_import_files && this.ai_import_files.length > 0) return true

			if (this.extra_prompts && this.extra_prompts.length > 0) {
				return this.extra_prompts.some(p => p.files && p.files.length > 0)
			}

			return false
		},

		validate_google_drive_source_selection() {
			const prompt1HasFiles = this.ai_import_files && this.ai_import_files.length > 0
			const prompt1HasGoogleDriveHtml = !empty(this.google_drive_source_text)

			if (prompt1HasFiles && prompt1HasGoogleDriveHtml) {
				this.$alert('Please use either uploaded PDF files or Google Drive HTML, not both.')
				return false
			}

			for (let i = 0; i < this.extra_prompts.length; i++) {
				const p = this.extra_prompts[i]

				const hasFiles = p.files && p.files.length > 0
				const hasGoogleDriveHtml = !empty(p.google_drive_source_text)

				if (hasFiles && hasGoogleDriveHtml) {
					this.$alert(`Prompt ${i + 2}: Please use either uploaded PDF files or Google Drive HTML, not both.`)
					return false
				}
			}

			return true
		},

		async run_prompt_once_start() {
			if (!this.validate_google_drive_source_selection()) return

			// ask user to confirm if running multiple prompts
			const ok = await this.confirm_multi_prompt_run()
			if (!ok) return

			if (this.downscale_pdfs_before_run) {
				// only call the downscale service if Prompt 1 actually has a PDF
				let has_pdf = this.ai_import_files.some(file => /\.pdf$/i.test(file.name))

				if (has_pdf) {
					let downscale_ok = await this.downscale_pdfs()

					// don't send the original PDF to Gemini if downscaling failed
					if (!downscale_ok) return
				}
			}

			// reset the last_response, then actually run the prompt
			this.last_response = ''
			setTimeout(x=>{
				this.run_prompt()
			}, 50)
		},

		/* Previous run_prompt() before attempting to run multiple prompts. Nick is leaving this here to fall back to incase problems arise
		async run_prompt() {
			// make sure schema is valid json
			let schema
			if (!empty(this.schema)) {
				try {
					schema = JSON.parse(this.schema)
				} catch(e) {
					console.error('schema parse error', e)
					this.$alert('Schema could not be parsed.')
					return
				}
			}

			let model_data = this.available_models[this.model]
			
			let payload = {
				prompt: this.prompt,
				model: this.model,
				// we'd like to use temperature 0, but Google says to stick with temperature = 1 for Gemini 3... After finding a lot of variance in responses Nick is trying temperature 0
				temperature: model_data.temperature,
				force_reprocess_files: this.ai_force_reprocess_files,
			}
			let override_options
			if (!empty(this.system_prompt)) {
				payload.system_prompt = this.system_prompt
				// add the satchelscript_protocol and extraction_logic to the system_prompt
				payload.system_prompt = payload.system_prompt.replace(/(<satchelscript_protocol>)(<\/satchelscript_protocol>)/, `$1\n${this.satchelscript_protocol}\n$2`)
				payload.system_prompt = payload.system_prompt.replace(/(<extraction_logic>)(<\/extraction_logic>)/, `$1\n${this.extraction_logic}\n$2`)
				
				//Attempting to rule out any variance/drift in prompts
				//console.log('FINAL SYSTEM PROMPT', payload instanceof FormData ? payload.get('system_prompt') : payload.system_prompt)

			}
			if (!empty(schema)) {
				payload.schema = JSON.stringify(schema)
			}
			if (this.ai_import_files.length > 0) {
				let fd = new FormData()
				for (let i = 0; i < this.ai_import_files.length; ++i) {
					fd.append(`file${i+1}`, this.ai_import_files[i])
				}
				for (let key in payload) {
					fd.append(key, payload[key])
				}
				payload = fd
				override_options = {contentType: false, processData: false}
			}
			// console.warn(payload); return;

			// record previous_last_response_cost_display before we run the ajax call, but don't update it until we finish
			let previous_last_response_cost_display = this.last_response_cost_display

			U.loading_start()
			let result = await this.run_prompt_ajax(payload, override_options)
			U.loading_stop()

			if (!result || result.status != 'ok') {
				this.$inform('Error')
				this.last_response = result.status
				return
			}
			console.log('full gemini response', result)

			// do calculations for cached tokens, then store
			if (result.force_cache_update) {
				result.usage_metadata.cached_input_tokens = 0
			} else {
				result.usage_metadata.cached_input_tokens = result.usage_metadata.cachedContentTokenCount ?? 0
			}
			result.usage_metadata.new_input_tokens = result.usage_metadata.promptTokenCount - result.usage_metadata.cached_input_tokens
			result.usage_metadata.output_tokens = result.usage_metadata.candidatesTokenCount
			this.last_usage_metadata = result.usage_metadata
			this.previous_last_response_cost_display = previous_last_response_cost_display

			if (empty(result.response)) this.last_response = 'NO RESPONSE'
			else this.last_response = result.response

			++this.n_runs
			this.total_cost_sum += this.last_response_cost

			// don't force_reprocess_files next time, unless the user edits the files available
			this.$store.commit('set', ['ai_force_reprocess_files', false])
		},
		*/

		async run_prompt() {
			const has_extras = this.extra_prompts.length > 0
			const forceReprocess = has_extras ? true : this.ai_force_reprocess_files

			// record previous cost display once
			let previous_last_response_cost_display = this.last_response_cost_display

			// build list of prompt blocks (prompt1 + extras)
			let blocks = [{
				prompt: this.prompt,
				files: this.ai_import_files,
				source_text: this.google_drive_source_text,
				source_type: this.google_drive_source_type,
				label: 'Prompt 1',
			}]
			for (let i = 0; i < this.extra_prompts.length; i++) {
				blocks.push({
					prompt: this.extra_prompts[i].prompt,
					files: this.extra_prompts[i].files,
					source_text: this.extra_prompts[i].google_drive_source_text,
					source_type: this.extra_prompts[i].google_drive_source_type,
					label: `Prompt ${i + 2}`,
				})
			}


			let start_time = Math.round(new Date().getTime() / 1000)
			U.loading_start()

			for (let i = 0; i < blocks.length; i++) {
				const b = blocks[i]

				// skip completely empty prompts
				if (empty(b.prompt) && empty(b.source_text)) continue
				let result = await this.run_single_prompt(b.prompt, b.files, forceReprocess, b.source_text, b.source_type)

				// append separation if needed
				if (!empty(this.last_response)) this.last_response = this.last_response.trimEnd() + `\n\n`

				if (!result || result.status != 'ok') {
					const msg = (result && result.status) ? result.status : 'Error'
					this.last_response += `ERROR (${b.label}): ${msg}`
					continue
				}

				// do calculations for cached tokens, then store
				if (result.force_cache_update) {
					result.usage_metadata.cached_input_tokens = 0
				} else {
					result.usage_metadata.cached_input_tokens = result.usage_metadata.cachedContentTokenCount ?? 0
				}

				result.usage_metadata.new_input_tokens = result.usage_metadata.promptTokenCount - result.usage_metadata.cached_input_tokens
				result.usage_metadata.output_tokens = result.usage_metadata.candidatesTokenCount
				this.last_usage_metadata = result.usage_metadata
				this.previous_last_response_cost_display = previous_last_response_cost_display

				// append raw response
				if (empty(result.response)) this.last_response += 'NO RESPONSE'
				else this.last_response += result.response

				++this.n_runs
				this.total_cost_sum += this.last_response_cost
			}
			
			U.loading_stop()
			this.elapsed_seconds = Math.round(new Date().getTime() / 1000) - start_time
			
			// don't force_reprocess_files next time, unless user edits prompt1 files
			this.$store.commit('set', ['ai_force_reprocess_files', false])
		},
		
		async run_single_prompt(promptText, filesArr, forceReprocess, sourceText = '', sourceType = '') {
			// make sure schema is valid json
			let schema = null
			if (!empty(this.schema)) {
				try {
					schema = JSON.parse(this.schema)
				} catch (e) {
					console.error('schema parse error', e)
					return { status: 'Schema could not be parsed.'}
				}
			}

			let model_data = this.available_models[this.model]

			let finalPrompt = !empty(sourceText) ? this.build_prompt_with_google_drive_source(promptText, sourceText, sourceType) : promptText
			
			let payload = {
				prompt: finalPrompt,
				model: this.model,
				temperature: model_data.temperature,
				force_reprocess_files: !!forceReprocess,
			}

			if (!empty(this.system_prompt)) {
				payload.system_prompt = this.system_prompt
				payload.system_prompt = payload.system_prompt.replace(/(<satchelscript_protocol>)(<\/satchelscript_protocol>)/, `$1\n${this.satchelscript_protocol}\n$2`)
				payload.system_prompt = payload.system_prompt.replace(/(<extraction_logic>)(<\/extraction_logic>)/, `$1\n${this.extraction_logic}\n$2`)
			}

			if (!empty(schema)) payload.schema = JSON.stringify(schema)

			console.log('payload', payload)
			
			// process all files together (or 1 or no files)...
			if (this.process_files_together || !filesArr || filesArr.length <= 0) {
				let override_options
				if (filesArr && filesArr.length > 0) {
					let fd = new FormData()
					for (let i = 0; i < filesArr.length; ++i) fd.append(`file${i + 1}`, filesArr[i])
					for (let key in payload) fd.append(key, payload[key])
					payload = fd
					override_options = { contentType: false, processData: false }
				}
			
				let result = await this.run_prompt_ajax(payload, override_options)
				return result || { status: 'Error' }

			// or process each file separately
			} else {
				let override_options = { contentType: false, processData: false }
				let result
				for (let i = 0; i < filesArr.length; ++i) {
					let start_time = Math.round(new Date().getTime() / 1000)
					console.warn(`Processing file ${i}...`)
					let file = filesArr[i]
					let fd_payload = new FormData
					fd_payload.append('file1', file)
					for (let key in payload) fd_payload.append(key, payload[key])
					
					let file_result = await this.run_prompt_ajax(fd_payload, override_options)
					let elapsed_time = Math.round(new Date().getTime() / 1000) - start_time
					console.log(`  elapsed time: ${Math.floor(elapsed_time / 60)} min, ${elapsed_time % 60} sec`)
					console.log(file_result)

					if (!file_result) return { status: 'Error' }
					
					// first file...
					if (!result) {
						result = file_result
						// add prefix to chapter -- needed for subsequent processing script
						//result.response = '* Chapter ' + result.response

					// subsequent files -- combine response and usage_metadata values
					} else {
						// add prefix to chapter -- needed for subsequent processing script
						//result.response = result.response.trimEnd() + `\n\n* Chapter ` + file_result.response
						for (let key in result.usage_metadata) {
							if (typeof(result.usage_metadata[key]) == 'number') {
								result.usage_metadata[key] += file_result.usage_metadata[key]
							}
						}
					}
				}
				return result
			}
		},

		run_prompt_ajax(payload, override_options) {
			return new Promise((resolve, reject) => {
				try {
					U.ajax('gemini_query', payload, result=>{
						resolve(result)
					}, override_options)
				} catch(e) {
					console.warn('error in gemini_query ajax', e)
					resolve(false)
				}
			})
		},

		add_additional_prompt() {
			this.extra_prompts.push ({
				prompt: '',
				files: [],

				// Google Drive source fields for this prompt
				google_drive_link: '',
				google_drive_source_text: '',
				google_drive_source_type: '',
				google_drive_source_loading: false,
				google_drive_source_error: '',
			})

			//console.log(this.extra_prompts)
		},

		remove_prompt(pi) {
			this.extra_prompts.splice(pi, 1)
		},

		clean_html_basic(rawHtml) {
			if (!rawHtml || typeof rawHtml !== 'string') return ''

			// Parse the raw HTML into a real DOM document so we can safely query and remove elements.
			const parser = new DOMParser()
			const doc = parser.parseFromString(rawHtml, 'text/html')

			// Remove non-essential tags and images to reduce size
			doc.querySelectorAll('script, style, meta, link, svg').forEach(el => el.remove())

			// Remove all images unless they have alt text. If they have alt text,
			// preserve that information as simple text for the LLM.
			doc.querySelectorAll('img').forEach(img => {
				const alt = (img.getAttribute('alt') || '').trim()

				if (alt) {
					const span = doc.createElement('span')
					span.textContent = `[Image: ${alt}]`
					img.replaceWith(span)
				} else {
					img.remove()
				}
			})

			// Remove presentation attributes from elements
			// Keep attributes that preserve meaning or structure
			doc.querySelectorAll('*').forEach(el => {
				const tag = el.tagName.toLowerCase()

				const allowedAttrs = {
					a: ['href'],
					td: ['rowspan', 'colspan'],
					th: ['rowspan', 'colspan', 'scope'],
					ol: ['start'],
				}

				const keep = allowedAttrs[tag] || []

				Array.from(el.attributes).forEach(attr => {
					if (!keep.includes(attr.name.toLowerCase())) {
						el.removeAttribute(attr.name)
					}
				})
			})

			const cleanedBody = doc.body ? doc.body.innerHTML : ''

			return `<!doctype html>
<html>
<head>
	<meta charset="utf-8">
</head>
<body>
${cleanedBody}
</body>
</html>`
		},

		preserve_google_italic_classes(rawHtml) {
			if (!rawHtml || typeof rawHtml !== 'string') return ''

			const parser = new DOMParser()
			const doc = parser.parseFromString(rawHtml, 'text/html')

			const wrap_contents_with_tag = (el, tagName) => {
				const tag = el.tagName.toLowerCase()
				const normalizedTag = String(tagName || '').toLowerCase()

				// Avoid wrapping an element that is already semantic italic/bold
				if ((normalizedTag === 'i' && (tag === 'i' || tag === 'em')) || (normalizedTag === 'b' && (tag === 'b' || tag === 'strong'))) {
					return false
				}

				// Avoid double-wrapping if this element is already inside italic/em or bold/strong
				if ((normalizedTag === 'i' && el.closest('i, em')) || (normalizedTag === 'b' && el.closest('b, strong'))) {
					return false
				}

				// Avoid double-wrapping if the element already has one wrapper child
				const meaningfulChildNodes = Array.from(el.childNodes).filter(node => {
					if (node.nodeType === Node.TEXT_NODE) return node.textContent.length > 0
					return true
				})

				if (meaningfulChildNodes.length === 1 && meaningfulChildNodes[0].nodeType === Node.ELEMENT_NODE) {
					const childTag = meaningfulChildNodes[0].tagName.toLowerCase()

					if ((normalizedTag === 'i' && (childTag === 'i' || childTag === 'em')) || (normalizedTag === 'b' && (childTag === 'b' || childTag === 'strong'))) {
						return false
					}
				}

				const wrapperEl = doc.createElement(normalizedTag)

				while (el.firstChild) {
					wrapperEl.appendChild(el.firstChild)
				}

				el.appendChild(wrapperEl)
				return true
			}

			let italicWrappedCount = 0
			let boldWrappedCount = 0

			// Preserve inline italics
			doc.querySelectorAll('[style]').forEach(el => {
				const style = el.getAttribute('style') || ''

				const hasInlineItalic = /(^|;)\s*font-style\s*:\s*italic\s*(;|$)/i.test(style)

				if (hasInlineItalic) {
					if (wrap_contents_with_tag(el, 'i')) italicWrappedCount++
				}
			})

			// Preserve inline bold
			doc.querySelectorAll('[style]').forEach(el => {
				const style = el.getAttribute('style') || ''

				const boldKeywordMatch = /(^|;)\s*font-weight\s*:\s*bold\s*(;|$)/i.test(style)
				const boldNumericMatch = style.match(/(^|;)\s*font-weight\s*:\s*(\d{3})\s*(;|$)/i)

				let hasInlineBold = false

				if (boldKeywordMatch) {
					hasInlineBold = true
				} else if (boldNumericMatch && boldNumericMatch[2]) {
					hasInlineBold = parseInt(boldNumericMatch[2], 10) >= 700
				}

				if (hasInlineBold) {
					if (wrap_contents_with_tag(el, 'b')) boldWrappedCount++
				}
			})

			console.log('[emphasis-debug] total italic elements wrapped:', italicWrappedCount)
			console.log('[emphasis-debug] total bold elements wrapped:', boldWrappedCount)

			return `<!doctype html>
${doc.documentElement.outerHTML}`
		},

		async pre_script_resource_summary_import(lines) {
			let textbook_title = $.trim(this.textbook_title)
			let item_type = $.trim(this.item_type)

			// Fall back to the current Resource Summary item type if the field is blank.
			if (empty(item_type)) item_type = 'Section'

			let sections = []
			let found_chapter = false
			let chapter_title = ''
			let current_section = null

			for (let line of lines) {
				line = $.trim(line)

				// Keep blank lines out of the generated SatchelScript
				if (empty(line)) continue

				// First non-empty line becomes the Chapter
				if (!found_chapter) {
					chapter_title = line
					found_chapter = true
					continue
				}

				// Resource title lines start with digits.period.digits followed by a space
				// Example: 11.1 Testing Structure in a Closed Environment
				if (line.search(/^(\d+\.\d+)\s+(.*)$/) == 0) {
					let hcs = RegExp.$1
					let statement = RegExp.$2

					current_section = {
						hcs,
						statement,
						title: `${hcs} ${statement}`,
						full_content_lines: [],
						description: ''
					}
					sections.push(current_section)

					continue
				}

				// All other lines belong to the current section's fullContent
				if (current_section) {
					current_section.full_content_lines.push(line)
				}
			}

			console.log('Resource Summary Import textbook title:', textbook_title)
			console.log('Resource Summary Import chapter title:', chapter_title)
			console.log('Resource Summary Import sections:', sections)

			// Run the AI call for every resource section before building the final SatchelScript output.
			if (sections.length > 0) {
				U.loading_start()

				try {
					for (let i = 0; i < sections.length; ++i) {
						let section = sections[i]
						let ai_prompt = this.build_resource_summary_ai_prompt(textbook_title, chapter_title, section)

						console.log(`Resource Summary Import AI section ${i + 1} of ${sections.length}:`, section.title)

						let result = await this.run_resource_summary_prompt_with_retry(ai_prompt, section.title)

						console.log(`Resource Summary Import AI result for ${section.title}:`, result)

						if (result && result.status === 'ok') {
							section.description = result.response || ''
						} else {
							let error_text = result && result.status ? result.status : 'Unknown error'
							section.description = `AI summary failed: ${error_text}`
						}
					}
				} finally {
					U.loading_stop()
				}
			}

			// Build the final SatchelScript output after the AI response is available
			let arr = []

			if (!empty(chapter_title)) {
				arr.push(`Chapter * :${chapter_title}`)
			}

			for (let section of sections) {
				arr.push(`${item_type} ** :${section.hcs} ${section.statement}`) // changed from Learning_Resource to Section
				arr.push('EXT-fullContent:')

				for (let content_line of section.full_content_lines) {
					arr.push(content_line)
				}

				if (!empty(section.description)) {
					arr.push('EXT-description:')
					arr.push(section.description)
				}
			}

			return arr
		},

		////////////////////////////////////////
		// gemini methods and helpers to support the resource summary import prescript
		build_resource_summary_ai_prompt(textbook_title, chapter_title, section) {
			let full_content = section.full_content_lines.join('\n').trim()

			return `You are an educational data analyst. Your task is to summarize the attached text from the textbook [TEXTBOOK_TITLE], specifically the section titled [SECTION_TITLE], distilling the text down to its essential concepts, themes, or skills.

Generate a prose summary of approximately 75 words using the following structural guidelines:

* State the content directly and declaratively. Describe the core ideas, processes, techniques, or relationships as established facts.

* Omit all learner-facing meta-language. Do not include references to the student, reader, or classroom expectations (explicitly avoid phrases like "Students must analyze," "Students will understand," "Mastery requires," or "The reader learns").

* Prioritize domain-specific academic vocabulary and the central concepts, frameworks, or methodologies introduced in the text.

* Do not write a bulleted list; instead, synthesize the content into a single, high-density paragraph of continuous prose.

* Avoid meta-commentary about the book itself (e.g., omit phrases like "In this section, the authors explain...").

Textbook Title: ${textbook_title}
Chapter Title: ${chapter_title}

<text_to_summarize>
${section.title}

${full_content}
</text_to_summarize>`
		},

		resource_summary_sleep(ms) {
			return new Promise(resolve => setTimeout(resolve, ms))
		},

		resource_summary_schema() {
			return JSON.stringify({
				type: 'object',
				properties: {
					output: {
						type: 'string'
					}
				},
				required: ['output'],
				additionalProperties: false
			})
		},

		resource_summary_should_retry_prompt_result(result) {
			if (!result) return true
		
			let text = ''
		
			if (typeof result === 'string') {
				text = result
			} else {
				text = [
					result.status,
					result.response,
					result.message,
					result.error,
				].filter(Boolean).join(' ')
			}
		
			text = String(text).toLowerCase()
		
			return (
				text.includes('503') ||
				text.includes('service unavailable') ||
				text.includes('overloaded') ||
				text.includes('unavailable') ||
				text.includes('try again later')
			)
		},

		resource_summary_prompt_ajax(payload) {
			return new Promise(resolve => {
				try {
					U.ajax('gemini_query', payload, result => {
						resolve(result)
					})
				} catch (e) {
					console.warn('Resource Summary Import gemini_query error', e)
					resolve(false)
				}
			})
		},

		async run_resource_summary_prompt_with_retry(prompt, runLabel = 'resource summary') {
			const max_attempts = 4
			const delay_ms = 3000

			let last_result = null

			for (let attempt = 1; attempt <= max_attempts; ++attempt) {
				console.log(`AI ${runLabel} attempt ${attempt} of ${max_attempts}`)

				let payload = {
					prompt,
					//model: 'gemini-3-flash-preview',
					model: 'gemini-3.5-flash-lite',
					temperature: 1,
					thinking_level: 'LOW',
					schema: this.resource_summary_schema(),
					response_property: 'output',
					force_reprocess_files: false,
				}

				last_result = await this.resource_summary_prompt_ajax(payload)

				if (last_result && last_result.status === 'ok') {
					return last_result
				}

				if (!this.resource_summary_should_retry_prompt_result(last_result) || attempt === max_attempts) {
					return last_result
				}

				console.warn(`Retrying AI ${runLabel} after transient error`, last_result)
				await this.resource_summary_sleep(delay_ms)
			}

			return last_result
		},
	}
}

/*
		// default schemas
		default_schema_base: {
			type: 'object',
			properties: {
				'output': {
					type: 'string',
				}
			},
			required: ['output'],
			additionalProperties: false
		},
		default_schema_array: {
			type: 'object',
			properties: {
				'output': {
					type: 'array',
					items: { 
						type: 'string',
					},
				}
			},
			required: ['output'],
			additionalProperties: false
		},
		default_schema_structured_array: {
			type: 'object',
			properties: {
				'output': {
					type: 'array',
					items: { 
						type: 'object',
						properties: {
							term: { type: 'string' },
							definition: { type: 'string' },
						},
						required: ['term', 'definition'],
						additionalProperties: false
					},
					minItems: 4,
					maxItems: 8,
					description: `An array of 4-8 objects.`
				}
			},
			required: ['output'],
			additionalProperties: false
		},
*/
</script>

<style lang="scss">

.k-ai-import-interface-wrapper {
	.k-case-item-importer-raw-text-area {
		textarea {
			max-height:calc(100vh - 180px);
			overflow: auto !important;
			font-family: monospace;
			font-size: 12px;
			line-height: 15px !important;
		}
	}
}

</style>